export default __webpack_public_path__ + "static/media/calendar_dummy_img.26a446b4.png";